import React from 'react';

import cx from 'classnames';
import styles from './styles.scss';

export default class Input extends React.PureComponent {
  render() {
    const { label, className = '', size = 'full', invalid, required, hide, ...rest } = this.props;

    const forId = 'input_' + this.props.name;

    const classes = cx(className, styles.input, styles[size], {
      [styles.invalid]: invalid,
      [styles.hide]: hide,
    });

    return (
      <div className={classes}>
        <label htmlFor={forId}>
          {label ? label : ''}&nbsp;{required ? <i>*</i> : null}
        </label>
        <input id={forId} {...rest} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/form/input.js